<template>
    <button
        class="ds-page-button transition-[background-color,_border,_color]"
        :class="[{ 'ds-selected': selected, 'ds-border': border }]"
        :disabled
    >
        <div class="relative">
            <slot />
        </div>
    </button>
</template>

<script lang="ts" setup>
export interface DsTableButtonProps {
    disabled?: boolean;
    selected?: boolean;
    border?: boolean;
}

defineProps<DsTableButtonProps>();
</script>

<style scoped lang="scss">
.ds-page-button {
    @apply h-8 w-8 p-[5px] text-base;
    @apply bg-semantic-secondary-default text-content-primary;
    @apply inline-flex min-w-max cursor-pointer items-center justify-center rounded-lg;

    &:focus-visible {
        @apply border outline-none ring-4 ring-ds-primary-200 ring-offset-ds-primary-200;
    }

    &:disabled {
        @apply cursor-not-allowed bg-opacity-20;
    }

    &:hover {
        @apply bg-semantic-secondary-hover;
    }

    &:active {
        @apply bg-semantic-secondary-pressed;
    }

    &.ds-selected {
        @apply border-ds-primary-900 bg-ds-primary-900 text-content-inverse;
    }
}

.ds-border {
    @apply border border-ds-primary-200;
}
</style>
